import React from 'react'

export default function NotFound(props) {

    return (
        <div>
            404 - NOT FOUND
        </div>
    );
}